import React from 'react';

interface FullScreenLayoutProps {
  children: React.ReactNode;
}

const FullScreenLayout = ({ children }: FullScreenLayoutProps) => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      {children}
    </div>
  );
};

export default FullScreenLayout;
